export default __webpack_public_path__ + "static/media/mentalHealth1.bd38932a.jpeg";